import useLorebookVisibilityConfirmation, {
  type LorebookVisibilitySource,
} from "@next-platform/client-common-core/lorebook/useLorebookVisibilityConfirmation";
import { LorebookVisibility } from "@next-platform/packages-ts-types";
import { useCallback } from "react";

type LorebookVisibilityFieldOptions = {
  lorebook?: LorebookVisibilitySource;
  value: LorebookVisibility;
  disabled?: boolean;
  onChange: (visibility: LorebookVisibility) => void;
};

const useLorebookVisibilityField = (options: LorebookVisibilityFieldOptions) => {
  const confirmation = useLorebookVisibilityConfirmation(options);
  const { onVisibilityChange } = confirmation;
  const onPublicClick = useCallback(() => onVisibilityChange(LorebookVisibility.PUBLIC), [onVisibilityChange]);
  const onPrivateClick = useCallback(() => onVisibilityChange(LorebookVisibility.PRIVATE), [onVisibilityChange]);

  return { ...confirmation, onPublicClick, onPrivateClick };
};

export default useLorebookVisibilityField;
